import LandingPage from './Pages/LandingPage'

function App() {
    return (
        <>
            <LandingPage/>
        </>
    );
}

export default App;
